import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import ThemeContext from '../../utils/theming';

const Link = styled.a`
    font-size: 8px;
    color: ${({ theme }) => theme.colors.primary};
    margin-top: 12px;
    letter-spacing: 2px;
    font-family: Averta;
    font-weight: 800;
    cursor: pointer;
    width: 100px;
    text-decoration: none;
    text-align: left;
`;

export const GetDirectionsComponent = props => (
    <Link
        href={`https://www.google.com/maps/place/${props.fullAddress}`}
        target="_blank"
        rel="noopener noreferrer"
        theme={useContext(ThemeContext)}
    >
        GET DIRECTIONS
    </Link>
);

GetDirectionsComponent.propTypes = {
    fullAddress: PropTypes.string.isRequired
};
